import api from "../Api";

import routes from "../constants/ApiRoutesConstants";

export async function GetRoles() {
  const res = await api.get(routes.GET_ROLES);

  return res;
}
